import * as React from "react"
import { navigate } from "gatsby";
import { useIntl } from "gatsby-plugin-intl";
import Layout from "../components/Layout/Layout";
import T from "../components/T/T";

export default function Privacy() {
    const intl = useIntl();
    const translatedText = intl.formatMessage({ id: 'privacy-text' });

    return (
        <>
            <title><T>privacy-title</T></title>

            <Layout hideFooter={false} hideCookies={false}>
                <div className="uk-container">
                    <div className="back-action">
                        <button className="back-button" onClick={() => navigate(-2)}>
                            <span><T>back-button</T></span>
                        </button>
                    </div>

                    <div className="terms-body-holder">
                        <h1><T>privacy-title</T></h1>

                        <div className="terms-content-holder" dangerouslySetInnerHTML={{ __html: translatedText }}></div>
                    </div>
                </div>
            </Layout>
        </>
    );
}
